import * as Reducers from './audio-video-check.reducer';
import * as MetaReducers from './audio-video-check.metareducer';

export const AudioVideoCheckReducers = { Reducers, MetaReducers };
